import type { RouteObject } from 'react-router-dom';

/**
 * Messages area. OWNED BY `m11-chat` (M11); see docs/BUILD-ORCHESTRATION.md.
 *
 * Add screens as children below. router.tsx already includes these routes, so a new
 * screen inside this area never needs a change outside this folder. Pages load lazily.
 */
export const messagesRoutes: RouteObject[] = [
  {
    path: 'messages',
    handle: { crumb: 'Messages' },
    children: [
      { index: true, lazy: async () => ({ Component: (await import('./MessagesPage')).MessagesPage }) },
    ],
  },
];
